import { get } from '@kit/utils/APIV1.js'

export const common = async() => {
  return get('common')
}